import { render } from "./mobileappsection.vue?vue&type=template&id=873073e8"
import script from "./mobileappsection.vue?vue&type=script&lang=js"
export * from "./mobileappsection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__